/*
 * Theme switcher
 *
 * Pico.css - https://picocss.com
 * Copyright 2019-2021 - Licensed under MIT
 */ /**
 * This file was modified from its original form but the original
 * copyright is to be maintained.
 */ const $c3531384623af4f2$export$ea9d603f8b43b010 = {
    // Config
    _scheme: "auto",
    buttonsTarget: ".theme-switcher",
    // Init
    init () {
        this.scheme = this._scheme;
        this.initSwitchers();
    },
    // Prefered color scheme
    get preferedColorScheme () {
        return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    },
    // Init switchers
    initSwitchers () {
        const buttons = document.querySelectorAll(this.buttonsTarget);
        buttons.forEach((el)=>{
            el.addEventListener("click", ()=>{
                this.scheme == "dark" ? this.scheme = "light" : this.scheme = "dark";
                el.setAttribute("aria-checked", `${el.checked}`);
            }, false);
            el.checked = this._scheme === "dark";
            el.setAttribute("aria-checked", `${el.checked}`);
        });
    },
    // Set scheme
    set scheme (scheme){
        if (scheme == "auto") this.preferedColorScheme == "dark" ? this._scheme = "dark" : this._scheme = "light";
        else if (scheme == "dark" || scheme == "light") this._scheme = scheme;
        this.applyScheme();
    },
    // Get scheme
    get scheme () {
        return this._scheme;
    },
    // Apply scheme
    applyScheme () {
        document.querySelector("html")?.setAttribute("data-theme", this.scheme);
    }
};
var $c3531384623af4f2$export$2e2bcd8739ae039 = $c3531384623af4f2$export$ea9d603f8b43b010;


const $b551b83af582cd52$var$osLookup = {
    linux: "Linux",
    darwin: "macOS",
    windows: "Windows"
};
let $b551b83af582cd52$var$latestRelease;
async function $b551b83af582cd52$var$getLatestVersion() {
    const resp = await fetch("https://api.github.com/repos/pulumi-desktop/app/releases/latest");
    if (resp.status !== 200) throw new Error(`response does not indicate a success: ${resp.statusText}`);
    $b551b83af582cd52$var$latestRelease = await resp.json();
}
function $b551b83af582cd52$var$enableDownloadButtons() {
    if (!$b551b83af582cd52$var$latestRelease) return;
    const buttons = document.getElementsByClassName("download-btn");
    for(let i = 0; i < buttons.length; i++){
        const btn = buttons[i];
        const os = btn.dataset.os;
        const arch = btn.dataset.arch;
        let releaseAsset;
        switch(os){
            case "linux":
                releaseAsset = $b551b83af582cd52$var$latestRelease.assets.find((a)=>a.name.endsWith("tar.gz"));
                break;
            case "darwin":
                if (arch) releaseAsset = $b551b83af582cd52$var$latestRelease.assets.find((a)=>a.name.includes(arch) && a.name.endsWith("dmg"));
                else // TODO: Temporary hack until all release assets have the architecture in their names.
                releaseAsset = $b551b83af582cd52$var$latestRelease.assets.find((a)=>!a.name.includes("arm64") && a.name.endsWith("dmg"));
                break;
            case "windows":
                releaseAsset = $b551b83af582cd52$var$latestRelease.assets.find((a)=>a.name.endsWith("exe"));
                break;
            default:
                throw new Error(`Unknown OS type ${os}`);
        }
        if (releaseAsset) {
            btn.href = releaseAsset.browser_download_url;
            btn.removeAttribute("disabled");
            const versionTooltip = `Version ${$b551b83af582cd52$var$latestRelease.tag_name}`;
            const versionTooltipClassName = "version-tooltip-target";
            if (btn.classList.contains(versionTooltipClassName)) btn.dataset.tooltip = versionTooltip;
            else {
                const el = document.querySelector(`.${os}.${versionTooltipClassName}`);
                if (!el) {
                    console.warn("Did not find a target el for the version tooltip");
                    return;
                }
                el.dataset.tooltip = versionTooltip;
            }
        }
    }
}
if (!window.fetch) console.error("Browser does not support fetch!");
else $b551b83af582cd52$var$getLatestVersion().then(()=>$b551b83af582cd52$var$enableDownloadButtons()).catch((err)=>console.error("Failed to fetch the latest version", err));
(0, $c3531384623af4f2$export$2e2bcd8739ae039).init();


//# sourceMappingURL=ui.d0112248.js.map
